import _createClass from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
/**
 * An Exception is considered a condition that a reasonable application may wish to catch.
 * An Error indicates serious problems that a reasonable application should not try to catch.
 * @public
 */
export var Exception = /*#__PURE__*/function (_Error) {
  _inherits(Exception, _Error);
  var _super = _createSuper(Exception);
  function Exception(message) {
    var _this;
    _classCallCheck(this, Exception);
    _this = _super.call(this, message); // 'Error' breaks prototype chain here
    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof Exception ? this.constructor : void 0).prototype); // restore prototype chain
    return _this;
  }
  return _createClass(Exception);
}( /*#__PURE__*/_wrapNativeSuper(Error));